const getters = {
  userId: state => state.user.info.userId,
  userPhone: state => state.user.info.userPhone,
}

export default getters